import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

import styles from '@components/typography/ButtonLink.module.css';
import linkStyles from '@components/typography/InternalLink.module.css';

// this component is used exclusively as an alternative to InternalLink when you want to use only an
// onClick handler. so, onClick is required for this component and href is not allowed (use
// InternalLink directly instead). buttons are also automatically in the tabindex, so it isn't
// needed as a prop.
type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;
type Props = Omit<ButtonProps, 'href' | 'tabIndex'> &
  Required<Pick<ButtonProps, 'onClick'>> & {
    expand?: boolean;
    stylized?: boolean;
  };

const ButtonLink = ({ className, expand = false, stylized = true, ...otherButtonProps }: Props) => {
  const classNames = [linkStyles.reset, styles.button];
  if (expand) {
    classNames.push(linkStyles.expand);
  }
  if (stylized) {
    classNames.push(linkStyles.stylized);
  }
  if (className) {
    classNames.push(className);
  }

  return <button className={classNames.join(' ')} {...otherButtonProps} />;
};

export default ButtonLink;
